import { render, staticRenderFns } from "./tournament.vue?vue&type=template&id=4c960ebb&"
import script from "./tournament.vue?vue&type=script&lang=js&"
export * from "./tournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports